import {CustomEqualitySet} from "custom-equality-set";
import * as JSONMapper from "json-mapper";
import {jsonProperty} from "json-mapper-reflect";
import {AvdbType} from "../avdb-type";
import {AvdbPricingBundle} from "./avdb-pricing-bundle";
import {AvdbPricingDeviceBundleAvdbType} from "./avdb-pricing-device-bundle-avdb-type";
import {AvdbPricingDeviceModel} from "./avdb-pricing-device-model";

export class AvdbPricingAircraftBundle extends AvdbPricingBundle {
	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingDeviceModel))
	qualifyingDeviceModels: Array<AvdbPricingDeviceModel>;

	constructor(data?: Partial<AvdbPricingAircraftBundle>) {
		super();
		Object.assign(this, data);
	}

	get allAvdbTypes(): CustomEqualitySet<AvdbType> {
		let result = new CustomEqualitySet<AvdbType>();
		for (let device of this.qualifyingDeviceModels) {
			for (let avdbType of device.deviceModelAvdbTypes) {
				result.add(new AvdbType({id: avdbType.id, name: avdbType.name}));
			}
		}
		return result;
	}

	avdbTypesForDeviceModelID(modelID: number): Array<AvdbPricingDeviceBundleAvdbType> {
		let model = this.qualifyingDeviceModels.find(m => m.modelID === modelID);
		if (model == null)
			return [];
		return model.deviceModelAvdbTypes;
	}

	get productOptions(): Array<string> {
		const productOptions: Array<string> = [];
		for (let deviceModel of this.qualifyingDeviceModels) {
			for (let avdbType of deviceModel.deviceModelAvdbTypes) {
				productOptions.push(...avdbType.productOptions);
			}
		}
		return productOptions;
	}

	equals(otherBundle: AvdbPricingBundle): boolean {
		if (otherBundle instanceof AvdbPricingAircraftBundle) {
			return (otherBundle.partKey === this.partKey);
		}
		else {
			return false;
		}
	}
}
